<template>
  <bm-icon
    icon="KeyboardArrowDown"
    class="expand-icon"
    :class="{
      'expand-icon-active': isExpanded,
      'hidden-icon': iconHidden,
    }"
    @click="onClick"
  />
</template>

<script setup lang="ts">
interface BmGridRowExpanderProps {
  isExpanded: boolean;
  iconHidden?: boolean;
}

withDefaults(defineProps<BmGridRowExpanderProps>(), {
  iconHidden: false,
});

interface BmGridRowExpanderEvents {
  (event: "toggle"): void;
}

const emit = defineEmits<BmGridRowExpanderEvents>();

const onClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();
  emit("toggle");
};
</script>

<style scoped lang="sass">
.expand-icon
  user-select: none
  cursor: pointer
  color: inherit

.expand-icon-active
  transform: rotate(-180deg)

.hidden-icon
  visibility: hidden

@media print
  .expand-icon
    display: none
</style>
